// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ad40150f","455":"6bfe3b86","977":"4e994f94"}[chunkId] + ".chunk.js";
};